<template>
  <div class="i-tree">
    <!--ref="tree"-->
    <!--:ref="refName"-->
    <Tree
      ref="tree"
      v-bind="$attrs"
      v-on="$listeners"
      :render="renderContent"
      :data="treeData"
      @on-check-change="getCheckedNodes"
      show-checkbox
      multiple
    ></Tree>
    <!-- <div style="background:red;">点击</div> -->
  </div>
</template>

<script>
import {loginMethod,filterTree} from '@/utils/common'
export default {
  data() {
    return {
      treeData: this.data ? this.data :this.$root.treeData,
      treeCode: this.code,
      treeAssocCode: this.assocCodes ? this.assocCodes : []
    }
  },
  props: {
    code: [Array],
    data: [Array],
    refName: {
      type: String,
      default: 'tree'
    },
    assoc: {
      type: Boolean,
      default: false
    },
    assocCodes: [Array]
  },
  watch: {
    treeCode: {
      handler(n) {
        this.defaultTreeData()
      },
      deep: true
    },
    data(n) {
      this.treeData = [...n]
    },
    code(n) {
      this.treeCode = [...n]
    },
    assoc(n) {
      this.defaultTreeData()
    },
    treeAssocCode(n) {
    },
    assocCodes(n) {
      this.treeAssocCode = [...n]
      this.defaultTreeData()
    }
  },
  async created() {
    let bool=await loginMethod(this.$root.platform)
    if(!bool){
      this.treeData=filterTree(this.treeData)
      console.log(this.treeData)
    }
  },
  mounted() {
    this.defaultTreeData()
  },
  methods: {
    renderContent(h, { root, node, data }) {
      return h(
        'div',
        {
          on: {
            click: () => {
            }
          },
          style: {
            display: 'flex',
            width: '100%'
          }
        },
        [
          h(
            'span',
            {
              on: {
                click: () => {}
              },
              style: {
                // 'min-width': '40px'
              }
            },
            data.title
          ),
          h(
            'CheckboxGroup',
            {
              props: {
                value: data.codes
              },
              on: {
                'on-change': (val) => {
                  data.codes = val
                  // if (data.childrens.length === val.length) {
                  if (val.length > 0) {
                    this.$set(data, 'checked', true)
                    this.$set(data, 'selected', true)
                  } else {
                    // data.selected = false
                    // data.checked = false
                  }
                }
              },
              style: {
                marginLeft: '20px',
                display: 'flex',
                'flex-wrap': 'wrap'
              }
            },
            (data.childrens || []).map((item) =>
              h(
                'Checkbox',
                {
                  props: {
                    label: item.code
                  },
                  style: {
                    color: '#2c3542!important',
                    minWidth: '50px'
                  }
                },
                item.title
              )
            )
          )
        ]
      )
    },
    getCheckedNodes(all, data) {
      // console.log(all, data, this.treeAssocCode, '-t')
      if (data.checked) {
        data.codes = check(data.children || data.childrens || [])
      } else {
        data.codes = close(data.children || data.childrens || [])
      }
      if (this.assoc) {
        this.treeAssocCode = all.length ? all.map(item => item.assocCode).filter(item => item) : []
      }
      this.$emit('changeCheck', this.treeAssocCode)

      // 遍历选中复选框
      function check(list) {
        return list.map((item) => {
          if (item.children) item.codes = check(item.children)
          if (item.childrens) item.codes = check(item.childrens)
          return item.code
        })
      }

      // 遍历取消复选框
      function close(list) {
        list.map((item) => {
          if (item.children) item.codes = close(item.children)
          if (item.childrens) item.codes = close(item.childrens)
        })
        return []
      }
    },
    getNodes(assoc) {
      // let data = this.$refs[this.refName].getCheckedAndIndeterminateNodes()
      let data = this.$refs.tree.getCheckedAndIndeterminateNodes()
      let params = data.map((item) => item.code)
      data.map((item) => {
        if (item.childrens) {
          params.push(...item.codes)
        }
      })
      let code = params.filter((item) => item)
      return code
    },
    defaultTreeData(data = this.treeData) {
      for (let i = 0; i < data.length; i++) {
        if (data[i].children) {
          this.defaultTreeData(data[i].children)
        }
        this.$set(data[i], 'expand', data[i].expand)
        if (!data[i].children && this.treeCode.includes(data[i].code)) {
          this.$set(data[i], 'checked', true)
          // data[i].assocCode && !this.treeAssocCode.includes(data[i].assocCode) ? this.treeAssocCode.push(data[i].assocCode) : '';
        } else {
          this.$set(data[i], 'checked', false)
          // this.$forceUpdate()
        }

        //TODO 未考虑不带码情况
        if (this.assoc) {
          let check = data[i].assocCode && this.treeAssocCode.includes(data[i].assocCode) || data[i].check
          // data[i].checked = check;
          this.$set(data[i], 'checked', check ? check : false)
          console.log(data[i], data[i].assocCode && this.treeAssocCode.includes(data[i].assocCode), check, 'check')
          if (check && data[i].childrens) {
            data[i].childrens.map(child => this.treeCode.includes(child.code) ? '' : this.treeCode.push(child.code))
          } else if (data[i].childrens) {
            console.log(data[i], data[i].title, this.treeCode, '-inn')
            data[i].childrens.map(item => {
              let i = this.treeCode.indexOf(item.code)
              if (i > -1) {
                // if (i > -1 && data[i].assocCode) {
                this.treeCode[i] = ''
                console.log(i, this.treeCode[i])
              }
            })
          }
        }
        // 添加子权限码
        let cs = data[i].childrens
        if (cs && cs.length > 0) {
          this.$set(data[i], 'codes', [])
          cs.map((item) => {
            if (this.treeCode.includes(item.code)) {
              data[i].codes.push(item.code)
            }
          })
        } else {
          this.$set(data[i], 'codes', [])
        }
      }
    }
  }
}
</script>

<style lang="less" scoped>
  .i-tree {
    /deep/ .ivu-tree-title {
      width: calc(100% - 30px);
      /*height: 30px;*/
      font-size: 14px;
      font-family: PingFang-SC-Heavy, PingFang-SC;
      color: #2c3542;

      > span {
        height: 30px;
        display: inline-flex !important;
        align-items: center;
        justify-content: space-between;
      }

      &:hover {
        background: transparent;
      }
    }
  }
</style>